// extracted by mini-css-extract-plugin
export default {"inputBackgroundImageQuestion":"VerifySecurityQuestion_inputBackgroundImageQuestion__XebrO","inputBackgroundImageAnswer":"VerifySecurityQuestion_inputBackgroundImageAnswer__c66IJ"};